import {ClientsActions, ClientsActionTypes} from '../actions';

export interface State {
  clientsList: Array<any>;
  managersList: Array<any>;
  sortedManagers: Array<any>;
}

export const initialState: State = {
  clientsList: [],
  managersList: [],
  sortedManagers: []
};

export function reducer(
  state: any = initialState,
  action: ClientsActions
): State {
  switch (action.type) {
    case ClientsActionTypes.GET_ALL_CLIENTS_SUCCESS:
    case ClientsActionTypes.GET_CLIENT_BY_PHONE_SUCCESS:
    case ClientsActionTypes.GET_CLIENT_SUCCESS: {
      return {
        ...state,
        clientsList: action.payload,
      };
    }

    case ClientsActionTypes.GET_MANAGER_BY_HEAD_MANAGER_SUCCESS:
    case ClientsActionTypes.GET_MANAGER_BY_FILIAL_SUCCESS: {
      return {
        ...state,
        managersList: action.payload,
      };
    }

    case ClientsActionTypes.GET_SORTED_MANAGER_BY_FILIAL_SUCCESS: {
      return {
        ...state,
        sortedManagers: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getClients = (state: State) => state.clientsList;
export const getManagers = (state: State) => state.managersList;
export const getSortedManagers = (state: State) => state.sortedManagers;
